.autoHeightWrapper {
  overflow: hidden;
  transition-timing-function: height ease-in-out width ease-in-out background-color ease-in-out;
  box-sizing: border-box;
  position: relative;
}

.autoHeightInner {
  height: fit-content;
}
